import { SPACING_40, SpacingVertical, Wizard } from 'mailup-web-components'

import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { changeWizardStepCallback } from '../recoil/callbacks/callbacks'
import {
  wizardEnableStep1State,
  wizardEnableStep2State,
  wizardEnableStep3State,
  wizardEnableStep4State,
  wizardSteps
} from '../recoil/state/page'
import Step1 from './step1/Step1'
import { Step2 } from './step2/Step2'
import { Step3 } from './step3/Step3'
import Step4 from './step4/Step4'

const WizardContainer = () => {
  const intl = useIntl()
  const { idCampaign } = useParams()
  const { wizardStep } = useRecoilValue(wizardSteps)
  const enableStep1 = useRecoilValue(wizardEnableStep1State)
  const enableStep2 = useRecoilValue(wizardEnableStep2State)
  const enableStep3 = useRecoilValue(wizardEnableStep3State)
  const enableStep4 = useRecoilValue(wizardEnableStep4State)

  // const { showLoading } = useRecoilValue(sendingPreviewState)

  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])

  useEffect(() => {
    // TODO loadWizardStepData()
  }, [wizardStep, idCampaign])

  const options = [
    {
      label: intl.formatMessage({
        id: 'Load.ContentsCampaignWizard.Step1TabEmail'
      }),
      value: 1,
      enabled: enableStep1
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentsCampaignWizard.Step2TabEmail'
      }),
      value: 2,
      enabled: enableStep2
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentsCampaignWizard.Step3TabEmail'
      }),
      value: 3,
      enabled: enableStep3
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentsCampaignWizard.Step4Tab'
      }),
      value: 4,
      enabled: enableStep4
    }
  ]

  const handleChangeWizard = (step) => {
    changeWizardStep(step)
  }

  return (
    <>
      <Wizard
        value={wizardStep}
        options={options}
        onChange={handleChangeWizard}
      />
      <SpacingVertical variant={SPACING_40} />
      {wizardStep === 1 && <Step1 />}
      {wizardStep === 2 && <Step2 />}
      {wizardStep === 3 && <Step3 />}
      {wizardStep === 4 && <Step4 />}
    </>
  )
}

export default WizardContainer
